import { getUUID } from '../utils/uuid';
import { delay, setSessionId } from '../utils/helper';
import ConsoleUtils from '../utils/console';

export default class WebSocketManager {
  constructor() {
    if (WebSocketManager.instance) {
      return WebSocketManager.instance;
    }
    this.forceDisconnect = false;
    this.socket = null;
    this.messageQueue = [];
    this.isConnected = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 50;
    this.listeners = new Map();
    this.send = this.send.bind(this);
    this.addListener = this.addListener.bind(this);
    this.first = false;

    // Monitor connectivity changes
    this.handleOnline = this.handleOnline.bind(this);
    this.handleOffline = this.handleOffline.bind(this);
    // window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
    WebSocketManager.instance = this;
  }
  static getInstance() {
    if (!WebSocketManager.instance) {
      WebSocketManager.instance = new WebSocketManager();
    }
    return WebSocketManager.instance;
  }

  init(options) {
    if (options.url && options.accessKey && options.widgetId && options.customerId) {
      this.url = options.url;
      this.accessKey = options.accessKey;
      this.widgetId = options.widgetId;
      this.customerId = options.customerId;
      this.connect();
    } else {
      ConsoleUtils.warn(`Please provide proper url/accesskey/widgetId/customerId`, options);
    }
  }

  async connect() {
    this.forceDisconnect = true;
    this.disconnect();
    await delay(500);
    this.forceDisconnect = false;
    const wsUrl = `${this.url}?access-key=${this.accessKey}&widgetId=${this.widgetId}&customerId=${this.customerId}`;
    this.socket = new WebSocket(wsUrl);
    this.socket.onopen = this.handleOpen.bind(this);
    this.socket.onmessage = this.handleMessage.bind(this, this.widgetId);
    this.socket.onclose = this.handleClose.bind(this);
    this.socket.onerror = this.handleError.bind(this);
  }

  handleOnline() {
    ConsoleUtils.log('Internet connection restored. Reconnecting WebSocket...');
    this.connect();
  }

  handleOffline() {
    ConsoleUtils.warn('Internet connection lost. Disconnecting WebSocket...');
    this.removeAllSocketMessages();
  }

  handleOpen() {
    ConsoleUtils.log('Connected!!!!!!!!');
    this.isConnected = true;
    this.reconnectAttempts = 0;
    this.processQueue();
    if (!this.first) {
      this.first = true;
      // this.send({
      //   id: '5397b5bf-e413-4dbc-bf9d-47bb7b5fbf53',
      //   payloadType: 'event',
      //   type: 'newPage',
      //   content: {
      //     pageNo: 1,
      //     pageSize: 20,
      //   },
      // });
    }
    this.notifyListeners('open');
  }

  handleMessage(widgetId, event) {
    const message = JSON.parse(event.data);
    setSessionId(widgetId, message?.sessionId || '');
    // ConsoleUtils.log('JSONmessage', message);
    this.notifyListeners('message', message);
  }

  handleClose() {
    ConsoleUtils.log('Disconnected');
    this.isConnected = false;
    if (!this.forceDisconnect) {
      this.notifyListeners('close');
      this.attemptReconnect();
    }
  }

  handleError(error) {
    this.notifyListeners('error', error);
  }
  // reConnect() {
  //   if (!this.isConnected) {
  //     this.reconnectAttempts = 0;
  //     this.attemptReconnect();
  //   }
  // }
  attemptReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      setTimeout(() => this.connect(), 5000);
    } else {
      this.notifyListeners('maxReconnectAttempts');
    }
  }

  send(message) {
    if (this.isConnected) {
      // ConsoleUtils.log('message to socket', message);
      this.socket.send(JSON.stringify(message));
    } else {
      this.messageQueue.push(message);
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        this.reconnectAttempts = 0;
        this.connect();
      }
    }
  }

  processQueue() {
    while (this.messageQueue.length > 0) {
      const message = this.messageQueue.shift();
      this.send(message);
    }
  }

  addListener(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
  }

  removeListener(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
    }
  }

  notifyListeners(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach((callback) => callback(data));
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
    }
  }

  async removeAllSocketMessages() {
    // this.send({
    //   id: getUUID(),
    //   type: 'text',
    //   content: {
    //     text: '/reset'
    //   }
    // });
    await delay(500);
    this.disconnect();
    this.socket = null;
    this.messageQueue = [];
    this.isConnected = false;
    this.reconnectAttempts = 0;
    this.first = false;
    this.forceDisconnect = true;
    ConsoleUtils.log('Message queue cleared.');
  }
}
